import React, { useState } from "react";
import GetStartedDialog from "./GetStartedDialog";
export default function Specialization() {
  const [open, setOpen] = useState(false);
  return (
    <div className="pt-20 lg:pt-40" id="skills">
      {" "}
      {/* Optional background */}
      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 items-center px-8 2xl:px-0">
        {/* Left Column */}
        <div>
          <ul className="list-none mb-4" data-aos="fade-up">
            <li className="text-[#F8F8F8] flex items-center before:content-[''] before:w-3 before:h-3 before:mr-2 before:bg-gradient-to-r before:from-[#6cfcb5] before:to-[#F0FF6C] before:rounded-full text-[16px] font-medium leading-[1.4em]">
              My Tech Stack
            </li>
          </ul>
          <h2
            className="text-[24px] md:text-[32px] xl:text-[42px] text-[#F8F8F8] font-semibold leading-[1.2em]"
            data-aos="fade-up"
          >
            Scalable web application <br />
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              development solutions
            </span>
          </h2>
        </div>

        {/* Right Column */}
        <div>
          <p className="text-[#F8F8F8] mb-6 text-[16px]" data-aos="fade-up">
            As a MERN Stack Developer, I build dynamic and scalable web
            applications that deliver reliable performance and seamless user
            experiences.
          </p>
          <button
            onClick={() => setOpen(true)}
            className="px-8 py-3 rounded-full font-semibold text-[#163031]
               bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] 
               hover:bg-gradient-to-l 
               transition-all duration-900 capitalize "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Start a Project
          </button>
        </div>
      </div>
      <GetStartedDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
